export default "__VITE_ASSET__DGHNnAx___"